var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMediumBannerShape = function SvgMediumBannerShape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 164.811,
    height: 341,
    viewBox: "45.38 0 164.811 341",
    xmlSpace: "preserve",
    preserveAspectRatio: "xMinYMax meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.326 17.759C62.03 6.226 82.151-.505 103.759-.505c47.001 0 87.519 31.546 100.483 76.842 0 .809.811 1.618.811 3.235.811 2.427 1.621 5.662 1.621 8.897 8.104 46.915-.811 101.109-39.707 153.685-25.932 35.59-59.967 64.709-98.863 86.549-8.104 4.044-12.156 5.662-17.828 8.896l-5.672 2.895v-76.501l1.621-.809c21.88-14.56 42.139-30.737 57.535-50.149h-.81c-21.344-.301-41.126-7.057-57.569-18.411"
  })));
};
export default SvgMediumBannerShape;